import React, { useState, useEffect, useRef } from 'react';
import MatrixUserRecord from './MatrixUserRecord';
import MultipleMatrixUserRecords from './MultipleMatrixUserRecords';
import OCIOUserRecord from './OCIOUserRecord';
import api from '../FetchComponents/FetchComponentsServices'
import PlaceHolderBox from './PlaceHolderBox'
import UserUpdateHistory from './UserUpdateHistory'
import { Loader } from "@progress/kendo-react-indicators";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import SyncModal from './SyncModal';
import { useSearchParams } from 'react-router-dom';
import '../Shared/UserLookup.css'

const UserLookup = ({ autoCompleteData, autoCompleteLoading, fetchAutoComplete, refetchAutocomplete }) => {
    const [idType, setIdType] = useState('workforceid');
    const [searchId, setSearchId] = useState('');
    const [idPlaceholder, setIdPlaceholder] = useState('e.g. 400124080');
    const [osuIdmid, setOsuIdmid] = useState('');
    const [loadingOCIO, setloadingOCIO] = useState(false);
    const [showOCIOPlaceholder, setShowOCIOPlaceholder] = useState(false);
    const [loadingMatrix, setloadingMatrix] = useState(false);
    const [showMatrixPlaceholder, setShowMatrixPlaceholder] = useState(false);
    const [matrixResponse, setMatrixResponse] = useState([]);
    const [matrixUserData, setMatrixUserData] = useState([]);
    const [ocioUserData, setOcioUserData] = useState(null);
    const [stagingData, setStagingData] = useState([]);
    const [stagingContainsOsuIdmid, setStagingContainsOsuIdmid] = useState(false);
    const [stagingUpdating, setStagingUpdating] = useState(false);
    const [displaySyncModal, setDisplaySyncModal] = useState(false);
    const [activeMatrixRecords, setActiveMatrixRecords] = useState([]);
    const [inactiveMatrixRecords, setInactiveMatrixRecords] = useState([]);
    const [allMatrixRecords, setAllMatrixRecords] = useState([]);
    const [loadingMatrixRecords, setLoadingMatrixRecords] = useState(false);
    const [useInactiveMatrixRecords, setUseInactiveMatrixRecords] = useState(false);
    const [dataSource, setDataSource] = useState('ocio');
    const userNamesRef = useRef([]);
    const [searchParams] = useSearchParams();
    const workforceid = searchParams.get("workforceid");
    const osuidmid = searchParams.get("osuidmid");
    const personid = searchParams.get("personid");
    const crednumber = searchParams.get("crednumber");

    const defaultState = {
        data: userNamesRef.current,
        value: "",
        opened: false
    }
    const [state, setState] = useState(defaultState);

    const handleDisplayNameSearch = async (searchType) => {
        clearSearch()
        setShowOCIOPlaceholder(true)
        setShowMatrixPlaceholder(true)
        setLoading(true)
        let user = null
        let matrixName = ''
        let matrixId = ''
        let workforceId = ''
        if (state.value && state.value.includes(" - ")) {
            const [name, id] = state.value.split(" - ")
            matrixName = name
            if (searchType === 'matrixDisplayName') {
                matrixId = id
            }
            else {
                workforceId = id
            }
        }

        if (autoCompleteData) {
            if (searchType === 'ocioDisplayName') {
                user = autoCompleteData.find((user) => `${user.n} - ${user.o}` === state.value)
                if (!user) {
                    user = activeMatrixRecords.find((user) => user.n === matrixName)
                    if (user) {
                        user.o = workforceId
                    }
                }
            } else if (searchType === 'matrixDisplayName') {
                if (matrixName.length && matrixId.length) {
                    user = autoCompleteData.find((user) => user.m.includes(Number(matrixId)))
                    if (!user) {
                        user = autoCompleteData.find((user) => user.n === matrixName)
                        if (user) {
                            user.m = [matrixId]
                        }
                    }
                }
            }
        }

        if (user) {
            console.log(`fetching data for ${user.n} - ${user.o} | ${user.m}`)
            if (user.o && user.o.length > 1) {
                await fetchOCIOdataByWorkforceID(user.o)
            } else if (user.m && user.m.length > 0) {
                await fetchOCIOdataByPersonID(user.m[0])
            }
            if (searchType === 'matrixDisplayName') {
                if (user.m && user.m.length > 0) {
                    await fetchMatrixDataByPersonID([user.m[0]])
                }
            } else {
                if (user.o && user.o.length > 1) {
                    await fetchMatrixDataByWorkForceID(user.o)
                }
            }
        } else if (searchType === 'matrixDisplayName') {
            if (matrixId.length) {
                console.log(`matrix name search fetching data for ${matrixName} - ${matrixId}`)
                await fetchOCIOdataByPersonID(matrixId)
                await fetchMatrixDataByPersonID([matrixId])
            }
        }
        setLoading(false)
    };

    const handleIDSearch = async (searchParamId) => {
        clearSearch()
        setShowOCIOPlaceholder(true)
        setShowMatrixPlaceholder(true)
        setLoading(true)
        const id = searchParamId ? searchParamId : searchId

        if (idType === 'workforceid') {
            await fetchOCIOdataByWorkforceID(id)
            await fetchMatrixDataByWorkForceID(id)
        }
        if (idType === 'osuIdmid') {
            await fetchOCIOdataByOsuIdmID(id)
        }
        if (idType === 'personId') {
            console.log('personId')
            await fetchOCIOdataByPersonID(id)
            await fetchMatrixDataByPersonID([id])
        }
        if (idType === 'credNumber') {
            await fetchMatrixDataByCredNumber(id)
        }
        setLoading(false)
    }

    const fetchOCIOdataByWorkforceID = async (workForceID) => {
        try {
            const OCIOUser = await api.GetOCIORecordByWorkForceID(workForceID)
            setOcioUserData(cleanUserData(OCIOUser));
        } catch (error) {
            console.error('Error fetching OCIOuser data:', error);
        } finally {
            setloadingOCIO(false)
        }
    }

    const fetchOCIOdataByPersonID = async (personID) => {
        try {
            const OCIOUser = await api.GetOCIORecordByPersonID(personID)
            setOcioUserData(cleanUserData(OCIOUser));
        } catch (error) {
            console.error('Error fetching OCIOuser data:', error);
        } finally {
            setloadingOCIO(false)
        }
    }

    const fetchOCIOdataByOsuIdmID = async (osuIdmID) => {
        try {
            const OCIOUser = await api.GetOCIORecordByOsuIdmId(osuIdmID)
            if (OCIOUser && OCIOUser.WorkForceIdNumber !== 0) {
                setOcioUserData(cleanUserData(OCIOUser));
                await fetchMatrixDataByWorkForceID(OCIOUser.WorkForceIdNumber)
            }
        } catch (error) {
            console.error('Error fetching OCIOuser data:', error);
        } finally {
            setloadingOCIO(false)
        }
    }

    const fetchMatrixDataByPersonID = async (personIDs) => {
        try {
            const matrixData = await Promise.all(
                personIDs.map(async (personId) => {
                    const matrixUser = await api.GetMatrixUserByPersonID(personId)
                    return matrixUser
                })
            );
            setMatrixResponse(matrixData)
            setMatrixUserData(matrixData.map((user) => cleanUserData(user)));
        } catch (error) {
            console.error('Error fetching matrixUser data:', error);
        } finally {
            setloadingMatrix(false)
        }
    }

    const fetchMatrixDataByCredNumber = async (credNumber) => {
        try {
            const matrixUser = await api.GetMatrixUserByCredNumber(credNumber)
            if (matrixUser && matrixUser.personID !== 0) {
                setMatrixResponse(matrixUser)
                setMatrixUserData([cleanUserData(matrixUser)]);
                if (matrixUser.userData && matrixUser.userData.user16) {
                    await fetchOCIOdataByWorkforceID(matrixUser.userData.user16)
                }
            }
        } catch (error) {
            console.error('Error fetching OCIOuser data:', error);
        } finally {
            setloadingMatrix(false)
        }
    }

    const fetchMatrixDataByWorkForceID = async (workForceID) => {
        try {
            const matrixUser = await api.GetMatrixUserByWorkForceID(workForceID)
            setMatrixResponse(matrixUser)
            setMatrixUserData([cleanUserData(matrixUser)]);
        } catch (error) {
            console.error('Error fetching matrixUser data:', error);
        } finally {
            setloadingMatrix(false)
        }
    }

    const fetchMatrixRecords = async () => {
        setLoadingMatrixRecords(true)
        let activeMatrixUserData = []
        let inactiveMatrixUserData = []
        try {
            activeMatrixUserData = await api.GetActiveMatrixRecords()
            const updatedUsers = activeMatrixUserData.map((record, index) => ({ id: index + 1, name: record, category: 'active' }))
            setActiveMatrixRecords(updatedUsers)
        } catch (error) {
            console.error('Error fetching active Matrix people data:', error);
        }

        try {
            inactiveMatrixUserData = await api.GetInactiveMatrixRecords()
            const updatedUsers = inactiveMatrixUserData.map((record, index) => ({ id: index + 1, name: record, category: 'inactive' }))
            setInactiveMatrixRecords(updatedUsers)
        } catch (error) {
            console.error('Error fetching inactive Matrix people data:', error);
        }
        setLoadingMatrixRecords(false)
    }

    const fetchStagingData = async () => {
        try {
            const stagingData = await api.GetStagingTableAdmin()
            setStagingData(stagingData)
            setStagingContainsOsuIdmid(false)
            if (osuIdmid.length) {
                let containsOsuIdmid = false;
                stagingData.map((record) => {
                    if (record.osUidmId.trim() === osuIdmid) {
                        containsOsuIdmid = true
                    }
                })
                setStagingContainsOsuIdmid(containsOsuIdmid)
            }
        } catch (error) {
            console.error('Error fetching staging data:', error);
        }
    }

    const AddToStagingTable = async () => {
        setStagingUpdating(true)
        try {
            await api.AddToStagingTable(osuIdmid)
        } catch (error) {
            console.error('Error adding staging data:', error);
        }
        fetchStagingData()
        setStagingUpdating(false)
    }

    const RemoveFromStagingTable = async () => {
        setStagingUpdating(true)
        try {
            await api.RemoveFromStagingTable(osuIdmid)
        } catch (error) {
            console.error('Error adding staging data:', error);
        }
        fetchStagingData()
        setStagingUpdating(false)
    }

    const clearSearch = () => {
        setOcioUserData(null)
        setMatrixUserData([])
        setOsuIdmid('')
    }

    const setLoading = (value) => {
        setloadingOCIO(value)
        setloadingMatrix(value)
    }

    const cleanUserData = (user) => {
        const cleanedUserData = [];

        for (const key in user) {
            if (key === 'OSUIDMId') {
                setOsuIdmid(user[key]);

                const matchFound = stagingData.some((record) => {
                    return record.osUidmId.trim() === user[key];
                });

                if (matchFound) {
                    setStagingContainsOsuIdmid(true);
                }
            }
            if (key === 'osUisMedcenterBadge') {
                cleanedUserData.push({ key, value: user[key] !== null ? user[key] : 'null' });
            } else if (
                user.hasOwnProperty(key) &&
                user[key] !== undefined &&
                user[key] !== null &&
                !isStringEmptyOrWhiteSpace(user[key])
            ) {
                if (typeof user[key] === 'boolean') {
                    user[key] = user[key] ? 'true' : 'false';
                }
                cleanedUserData.push({ key, value: user[key] });
            }
        }
        return sortGridData(cleanedUserData)
    }

    const sortGridData = (cleanedUserData) => {
        const specialKeys = ['firstname', 'lastname', 'personid', 'givenname', 'surname', 'preferredname', 'workforceidnum', 'osUdeptIsMedcenter', 'osUbuckID', 'osupsEmplID', 'status', 'inactiveReason', 'modifiedDateTime'];

        return cleanedUserData.slice().sort((a, b) => {
            const keyA = a.key.toLowerCase();
            const keyB = b.key.toLowerCase();

            if (specialKeys.includes(keyA)) {
                return -1;
            }
            if (specialKeys.includes(keyB)) {
                return 1;
            }

            if (keyA < keyB) {
                return -1;
            }
            if (keyA > keyB) {
                return 1;
            }
            return 0;
        });
    };

    const isStringEmptyOrWhiteSpace = (str) => {
        if (typeof str !== 'string') {
            return false
        }
        return str.trim() === '';
    };

    const onChange = (event) => {
        let value = event.target.value ? event.target.value : '';
        const filterData = (value) => {
            const data = dataSource === 'ocio' ? userNamesRef.current : allMatrixRecords;
            const filter = {
                field: 'name',
                value: value,
                operator: "startswith",
                ignoreCase: true,
            };
            return filterBy(data, filter);
        };
        const stateData = value.length < 3
            ? { data: [], opened: false }
            : { data: filterData(value), opened: true };
        const eventType = event.nativeEvent.type;
        const nativeEvent = event.nativeEvent;
        const valueSelected = eventType === "click" || (eventType === "keydown" && nativeEvent.keyCode === 13);
        if (valueSelected) {
            stateData.opened = false;
        }
        if (value && value.name) {
            value = value.name
        }
        setState({ value: value, ...stateData });
    };

    const listNoDataRender = (element) => {
        const noData = (
            !autoCompleteLoading ? <h4>No User Found</h4> : <h4>Loading AutoComplete Data...</h4>
        );
        return React.cloneElement(
            element,
            {
                ...element.props,
            },
            noData
        );
    };

    const itemRender = (li, itemProps) => {
        const itemChildren = (
            itemProps.dataItem.category === ('inactive')
                ? <span style={{ color: "rgb(187, 0, 0)", }}>{itemProps.dataItem.name}</span>
                : itemProps.dataItem.name
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    useEffect(() => {
        if (ocioUserData) {
            setShowOCIOPlaceholder(false)
        } else {
            setStagingContainsOsuIdmid(false)
        }
    }, [loadingOCIO]);

    useEffect(() => {
        if (matrixUserData.length > 0) {
            setShowMatrixPlaceholder(false)
        }
    }, [loadingMatrix]);

    useEffect(() => {
        console.log('autoCompleteLoading = ' + autoCompleteLoading)
        userNamesRef.current = []
        if (!autoCompleteLoading && autoCompleteData) {
            const names = autoCompleteData.map((user, index) => {
                if (user.m) {
                    return { id: index + 1, name: `${user.n} - ${user.o}`, category: 'ocio' }
                }
            })
            userNamesRef.current = names.sort(sortRecords)
        }
        forceUpdateAutoComplete(state.value)
    }, [autoCompleteLoading])

    useEffect(() => {
        if (idType === 'workforceid') {
            setIdPlaceholder('e.g. 400124080')
        }
        if (idType === 'osuIdmid') {
            setIdPlaceholder('e.g. IDM802511691')
        }
        if (idType === 'personId') {
            setIdPlaceholder('e.g. 298223')
        }
        if (idType === 'credNumber') {
            setIdPlaceholder('e.g. 401240800')
        }
    }, [idType])

    useEffect(() => {
        if (dataSource === 'matrix') {
            setState({ data: allMatrixRecords, value: '' });
        } else {

            setState({ data: userNamesRef.current, value: '' });
        }
        forceUpdateAutoComplete('')
    }, [dataSource]);

    const forceUpdateAutoComplete = (value) => {
        onChange({
            target: {
                value: value,
            },
            nativeEvent: {
                type: 'click',
            },
        })
    }

    useEffect(async () => {
        useInactiveMatrixRecords
            ? setAllMatrixRecords(activeMatrixRecords.concat(inactiveMatrixRecords).sort(sortRecords))
            : setAllMatrixRecords(activeMatrixRecords.sort(sortRecords))

    }, [useInactiveMatrixRecords, activeMatrixRecords, inactiveMatrixRecords]);

    function sortRecords(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    useEffect(async () => {
        console.log('autoCompleteLoading = ' + autoCompleteLoading)
        if (workforceid || osuidmid || personid || crednumber) {
            if (workforceid) {
                setIdType('workforceid')
                setSearchId(workforceid)
                await handleIDSearch(workforceid)
            }
            if (osuidmid) {
                setIdType('osuIdmid')
                setSearchId(osuidmid)
                await handleIDSearch(osuidmid)
            }
            if (personid) {
                console.log(personid)
                setIdType('personId')
                setSearchId(personid)
                await handleIDSearch(personid)
            }
            if (crednumber) {
                setIdType('credNumber')
                setSearchId(crednumber)
                await handleIDSearch(crednumber)
            }
        }
        if (!autoCompleteData && !autoCompleteLoading) {
            await fetchAutoComplete()
        }
        await fetchStagingData()
        await fetchMatrixRecords()
    }, []);

    return (
        <>
            {displaySyncModal && <SyncModal
                toggleDialog={() => setDisplaySyncModal(!displaySyncModal)}
                matrixUserData={matrixUserData} matrixResponse={matrixResponse}
                oSUidmId={osuIdmid}
            />}
            <h1 className='page-title'>User Lookup</h1>
            <div className='top-search-container'>
                <div className='search-box'>
                    <label htmlFor='display-name-form'>Search by Display Name:</label>
                    <div className='search-container'>
                        <form id='display-name-form' className="k-form" onSubmit={(e) => e.preventDefault()}>
                            <div>
                                <fieldset>
                                    <AutoComplete
                                        style={{
                                            width: "400px",
                                        }}
                                        data={state.data}
                                        value={state.value}
                                        onChange={onChange}
                                        opened={state.opened}
                                        listNoDataRender={listNoDataRender}
                                        itemRender={itemRender}
                                        placeholder="e.g. Buckeye, Brutus"
                                        id={'ocio-search'}
                                    />
                                </fieldset>
                                <div className='data-selection-container'>
                                    <label>
                                        <input type="checkbox" name="ocioDataSource" checked={dataSource === 'ocio'} onChange={() => setDataSource('ocio')} />
                                        OCIO Display Names:
                                    </label>
                                    <label>
                                        <input type="checkbox" name="matrixDataSource" checked={dataSource === 'matrix'} onChange={() => setDataSource('matrix')} />
                                        Matrix Display Names:
                                    </label>
                                    {
                                        !loadingMatrixRecords && inactiveMatrixRecords.length > 0 && dataSource === 'matrix' &&
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="useInactiveRecords"
                                                checked={useInactiveMatrixRecords}
                                                onChange={() => setUseInactiveMatrixRecords(useInactiveMatrixRecords ? false : true)}
                                            />
                                            Include Inactive Records:
                                        </label>
                                    }
                                </div>
                            </div>
                        </form>
                        {
                            dataSource === 'ocio' &&
                            <div className='search-button-container'>
                                <button disabled={autoCompleteLoading && !autoCompleteData || !state.value} className='k-button-solid-secondary' onClick={() => handleDisplayNameSearch('ocioDisplayName')}>Search</button>
                                <button disabled={autoCompleteLoading}
                                    className='auto-refresh-btn' onClick={refetchAutocomplete}>
                                    {!autoCompleteLoading ? 'Refresh Autocomplete' : <span><Loader className='spinner' size="small" type={"infinite-spinner"} /> Loading Autocomplete</span>}
                                </button>
                            </div>
                        }
                        {
                            dataSource === 'matrix' &&
                            <div className='search-button-container'>
                                <button disabled={!allMatrixRecords && !allMatrixRecords.length || !state.value} className='k-button-solid-secondary' onClick={() => handleDisplayNameSearch('matrixDisplayName')}>Search</button>
                                <button disabled={loadingMatrixRecords}
                                    className='auto-refresh-btn' onClick={() => fetchMatrixRecords()}>
                                    {!loadingMatrixRecords ? 'Refresh Autocomplete' : <span><Loader className='spinner' size="small" type={"infinite-spinner"} /> Loading Autocomplete</span>}
                                </button>
                            </div>
                        }
                    </div>
                    {
                        !autoCompleteLoading && !autoCompleteData && <p className='autocomplete-warning'>AutoComplete data failed to load. Please try refreshing or search by WorkForce ID</p>
                    }
                </div>
                <div className='search-box or-search-box'>
                    <label htmlFor='id-search-form'>Or search by ID:</label>
                    <div className='search-container'>
                        <form id='id-search-form' className="k-form" onSubmit={(e) => e.preventDefault()}>
                            <fieldset>
                                <input
                                    type='text'
                                    value={searchId}
                                    onChange={(e) => setSearchId(e.target.value)}
                                    id={'id-search-input'}
                                    className='search-input'
                                    placeholder={idPlaceholder}
                                />
                            </fieldset>
                            <div className='data-selection-container id-checkboxes'>
                                <div>
                                    <label>
                                        <input type="checkbox" name="workforceidCheckBox" checked={idType === 'workforceid'} onChange={() => setIdType('workforceid')} />
                                        WorkforceID:
                                    </label>
                                    <label>
                                        <input type="checkbox" name="osuIdmidCheckBox" checked={idType === 'osuIdmid'} onChange={() => setIdType('osuIdmid')} />
                                        OsuIdmID:
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input type="checkbox" name="personIdCheckBox" checked={idType === 'personId'} onChange={() => setIdType('personId')} />
                                        PersonID:
                                    </label>
                                    <label>
                                        <input type="checkbox" name="credNumberCheckBox" checked={idType === 'credNumber'} onChange={() => setIdType('credNumber')} />
                                        Credential Number:
                                    </label>
                                </div>
                            </div>
                        </form>
                        <div className='search-button-container'>
                            <button className='k-button-solid-secondary' disabled={!searchId.length} onClick={() => handleIDSearch()}>Search</button>
                        </div>
                    </div>
                </div>
                <div className='search-box'>
                    <div className='sync-button-container'>
                        {
                            ocioUserData && osuIdmid.length > 0 && <>
                                {
                                    stagingData && stagingContainsOsuIdmid
                                        ? <button disabled={stagingUpdating} className='k-button-solid-secondary k-button-lg' onClick={() => RemoveFromStagingTable()}>{stagingUpdating ? <Loader className='spinner-small-white' size="small" type={"infinite-spinner"} /> : 'REMOVE FROM STAGING'}</button>
                                        : <button disabled={stagingUpdating} className='k-button-solid-secondary k-button-lg' onClick={() => AddToStagingTable()}>{stagingUpdating ? <Loader className='spinner-small-white' size="small" type={"infinite-spinner"} /> : 'ADD TO STAGING'}</button>
                                }
                            </>
                        }
                        {
                            matrixUserData.length > 0
                            && ocioUserData
                            && ocioUserData.personID !== 0
                            && <button className='k-button-solid-secondary k-button-lg' onClick={() => setDisplaySyncModal(true)}>SYNC USER DATA</button>
                        }
                    </div>
                </div>
            </div>
            <div className='data-container'>
                <div className={'data-box ocio-data-box'}>
                    {ocioUserData && <OCIOUserRecord data={ocioUserData} />}
                    {showOCIOPlaceholder && <PlaceHolderBox dataSource={'OCIO'} loading={loadingOCIO} />}
                </div>
                <div className={'data-box matrix-data-box'}>
                    {matrixUserData.length > 1 &&
                        <>
                            <div className='data-warning'>Multiple Matrix Records Found</div>
                            <MultipleMatrixUserRecords data={matrixUserData} />
                        </>
                    }
                    {matrixUserData.length === 1 && <MatrixUserRecord data={matrixUserData[0]} />}
                    {showMatrixPlaceholder && <PlaceHolderBox dataSource={'Matrix'} loading={loadingMatrix} />}
                </div>
            </div>
            {osuIdmid.length > 1 && <UserUpdateHistory osuIdmID={osuIdmid} />}
        </>
    )
};

export default UserLookup;